import React from "react";
import { WACategoryScreenProps } from "../../WANavigation";
import { WACategoryTodoCategorySelectTypeComponent } from "../WACategoryTodoCategories/WACategoryTodoCategorySelectTypeComponent";

export function WACategoryDefaultTodoCategory(
  props: WACategoryScreenProps<"WACategoryDefaultTodoCategory">
) {
  return (
    <WACategoryTodoCategorySelectTypeComponent
      unitSize={props.route.params.unitSize}
      maxSize={props.route.params.maxSize}
      storecastId={props.route.params.storecastId}
      categoryId={props.route.params.categoryId}
      onAdd={(type) => {
        if (type === "WidgetTodoSummary") {
          props.navigation.navigateDeprecated("WidgetAddTodoSummary", {
            categoryId: props.route.params.categoryId,
            storecastId: props.route.params.storecastId,
            defaultTeams: props.route.params.defaultTeams,
            unitSize: props.route.params.unitSize,
            maxSize: props.route.params.maxSize,
            position: props.route.params.position,
          });
        } else {
          props.navigation.navigateDeprecated("WidgetAddTodoCategory", {
            categoryId: props.route.params.categoryId,
            storecastId: props.route.params.storecastId,
            defaultTeams: props.route.params.defaultTeams,
            unitSize: props.route.params.unitSize,
            maxSize: props.route.params.maxSize,
            position: props.route.params.position,
          });
        }
      }}
    />
  );
}
